import {
  MEMBER_DETAILS_CHILD_PATHS,
  MEMBER_DETAILS_PATH
} from '@bo-constants/routes';
import { Table, TableBody, TableHeader } from '@library/components/table';
import { useCallback, useContext } from 'react';
import { Loading } from '@library/components/Loading';
import { MEMBER_GROUP_MEMBERS_HEADER } from '@bo-constants/memberGroups';
import { MemberGroupMemberRow } from '@library/components/table/rows/MemberGroupMemberRow';
import { MemberGroupsContext } from '@bo-hooks/memberGroups/useMemberGroupsContext';
import { NoResults } from '@library/components/NoResults';
import { PaginationButtons } from '@library/components/buttons/PaginationButtons';
import { useNavigate } from 'react-router-dom';

export function MemberGroupsMemberTable() {
  const {
    members,
    isFetchingMembers: isLoading,
    membersPagination
  } = useContext(MemberGroupsContext);
  const navigate = useNavigate();

  const onRowClick = useCallback(
    (id: string) => {
      navigate(
        `${MEMBER_DETAILS_PATH.replace(':memberId', id)}/${MEMBER_DETAILS_CHILD_PATHS.profile}`
      );
    },
    [navigate]
  );

  const menuActions = {
    onEdit: onRowClick
  };

  if (isLoading) {
    return <Loading loadingMessage="Loading Members" />;
  }

  if (!members?.length) {
    return (
      <NoResults
        className="m-0"
        label="Use the search bar to search for a member in this group"
      />
    );
  }

  return (
    <Table>
      <div
        className="flex flex-col overflow-x-auto"
        data-testid="MemberGroupMembers"
      >
        <TableHeader
          headers={MEMBER_GROUP_MEMBERS_HEADER}
          // sort={sort}
          // onSort={onSort}
        />
        <TableBody>
          {members.map((member) => (
            <MemberGroupMemberRow
              key={member.id}
              member={member}
              onRowClick={onRowClick}
              menuActions={menuActions}
            />
          ))}
        </TableBody>
      </div>

      <PaginationButtons
        currentPage={membersPagination.page}
        handlePageChange={membersPagination.setPage}
        totalPages={membersPagination.totalPages}
      />
    </Table>
  );
}
